// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-availability{display:flex;font-size:14px;line-height:24px;color:var(--1q04nu9)}.c-availability svg{margin-right:4px}.c-availability--active{color:var(--z03ht2)}", ""]);
// Exports
module.exports = exports;
